import React from 'react';
import styled from "styled-components";
import {getLogo, getAgencyProfileUrl} from "@models/agency";
import {isEmpty} from "@helpers/helpers";
import useTrans from "@hooks/translation";
import Avatar from "@atoms/avatar";
import Icon from "@atoms/icon";
import ButtonBase from "@atoms/button.base";
import PhoneBlackIcon from '@icons/phone.svg';
import VerifiedBadgeIcon from '@icons/verified-badge.svg';
import VIPIcon from '@icons/vip.svg';


function AgencyBannerPromote({agency, className, setContactInfo, sectionTitle = null}) {

    if (!isEmpty(agency)) {
        const paramForMakeUrl = {
            agency_username: agency.username,
            agency_city_name: agency.city_name,
            agency_district_name: agency.district_name,
            agency_slug: agency.slug,
            agency_name: agency.name
        };

        const isVIP = agency.is_vip ?? false;

        const vipBadge = (vip) => {
            return vip ? <Icon width={32} height={16} className="vip-icon"><VIPIcon/></Icon> : ''
        }


        return (
            <div className={" " + (className ?? '')}>
                <p className="mb-16 d-block"><strong className="h2">{sectionTitle ?? 'املاک منتخب منطقه'}</strong></p>

                <Card className="d-flex align-items-center rounded-8">

                    <a href={getAgencyProfileUrl(paramForMakeUrl)} target="_blank" className="position-relative">
                        <Avatar src={getLogo((!isEmpty(agency) && !isEmpty(agency.avatar)) ? agency.id : '')} size={80} type="agency"/>
                        {vipBadge(isVIP)}
                    </a>

                    <Info>

                        <RealtorName href={getAgencyProfileUrl(paramForMakeUrl)} className="d-flex align-items-center justify-content-center justify-content-lg-start" target="_blank">
                            <h4>{agency.name}</h4>

                            {
                                (!isEmpty(agency) && agency.authenticated) ?
                                    <Icon width={16} height={16} className="mr-4"><VerifiedBadgeIcon/></Icon>
                                    : ''
                            }
                        </RealtorName>

                        {/*<span className="d-none d-lg-block">املاک منتخب منطقه</span>*/}
                        <Slogan className="d-block">
                            {
                                (!isEmpty(agency.slogan)) ?
                                    agency.slogan
                                    :
                                    (
                                        (!isEmpty(agency.city_name) ? (agency.city_name + '، ') : '') +
                                        (!isEmpty(agency.district_name) ? (agency.district_name + '، ') : '') +
                                        (!isEmpty(agency.address) ? agency.address : '')
                                    )
                            }
                        </Slogan>
                    </Info>


                    <ContactButton size="sm" onClick={() => setContactInfo({show: true, property_id: null, realtor_id: null, agency_id: agency.id, isOnList: true})}>
                        <Icon width={16} height={16} className="ml-8"><PhoneBlackIcon/></Icon>
                        {useTrans('main.contact_info')}
                    </ContactButton>
                </Card>
            </div>
        )
    } else {
        return '';
    }
}

export default React.memo(AgencyBannerPromote);

// styles
const ContactButton = styled(ButtonBase)`
  margin-right: auto;

  @media (max-width: ${props => props.theme.screenSmMax}) {
    margin-top: 16px;
    margin-right: 0;
  }

  svg {
    path, g {
      stroke: #ffffff;
      stroke-width: 1.3px;
    }
  }
`;

const Card = styled.div`
  background: ${props => props.theme.info} url(/_img/pattern.svg) repeat space;
  padding: 32px;
  background-size: 39px;
  object-fit: contain;

  @media (max-width: ${props => props.theme.screenSmMax}) {
    padding: 24px;
    flex-direction: column;
    text-align: center;
  }

  .vip-icon {
    position: absolute;
    bottom: -4px;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const RealtorName = styled.a`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Info = styled.div`
  margin-right: 16px;
  text-align: right;

  @media (max-width: ${props => props.theme.screenSmMax}) {
    width: 100%;
    margin-top: 16px;
    margin-right: 0;
    text-align: center;
  }
`;

const Slogan = styled.span`
  line-height: 1.8;
  color: #222222;
`;